<template>
  <div>
    <div ref="chart" class="videoDay" v-show='info'></div>
  <div>
    <none-data v-show='!info' :height="3.5" />
  </div>
  </div>
  
</template>

<script>
import moment from 'moment'
const today = new Date();
const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
const formattedYesterday = `${yesterday.getFullYear()}${String(yesterday.getMonth() + 1).padStart(2, '0')}${String(yesterday.getDate()).padStart(2, '0')}`;
export default {
  props:{
    dayNum:Number,
    onlySales:Boolean,
    worksStr:String
  },
  data() {
    return {
      info:true
    };
  },
  mounted() {
    this.getvideoDay()
  },
  computed:{

  },
  watch:{
    dayNum:{
      handler() {
        this.getvideoDay()
      }
    },
    onlySales: {
      handler() {
        this.getvideoDay()
      }
    },
    worksStr: {
      handler() {
        this.getvideoDay()
      }
    }
  },
  methods: {   
    text(item) {
      if(this.worksStr === 'views') {
        return {name:'作品热度',value: this.$retainWan(item.views,0,false)}
      } else if(this.worksStr === 'likes') {
        return {name:'作品点赞',value: this.$retainWan(item.likes,0,false)}
      } else {
        return {name:'作品评论',value: this.$retainWan(item.comments,0,false)}
      }
    },    
    getvideoDay() {
           this.$get({
          road: 'opusHeatStatistic',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: this.dayNum, time: formattedYesterday,onlySales:this.onlySales,recentOpusCount:30 },
          version: 'v22'
        }).then(res => {
         this.info = res.data.x.length && res.data.y.length
         const arr1 = res.data.y.map(item => {
          if(this.worksStr === 'views') {
        return item.views
        } else if(this.worksStr === 'likes') {
        return item.likes
        } else {
        return item.comments
      }
        })
         const arr2 = res.data.y.map(item => JSON.stringify(item))
        this.drawChart({x:arr1,y:arr2});
        }).finally(() => {
          this.$toast.clear()
        })
    },     
    // 字体适配
  FontChart(res) {
          //获取到屏幕的宽度
          var clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth; 
          if (!clientWidth) return; //报错拦截：
          let fontSize = 10 * (clientWidth / 1920);
          return res * fontSize;
        },
    drawChart(info) {
      echarts.init(this.$refs.chart).setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: val => {
            const item = JSON.parse(val[0].name)
            return `<div style="display:flex;font-family: number-bold;">
              <img src="${item.cover}" style="width:38px;height:56px;border-radius: 4px;margin-right: 6px;"/>
              <div style="display:flex;flex-direction: column;justify-content: space-between;height:56px;">
                <div style="width:126px;font-size:12px;color:#141B27;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;flex:1">
                  ${item.caption}
                <div>
                <div style="flex:1;position: relative;top: -3px;">
                 发布时间 ${moment(item.releaseTime * 1000).format('MM-DD HH:mm')}
                <div>
                <div style="flex:1;position: relative;top: -3px;">
                 ${this.text(item).name} ${this.text(item).value}
                <div>
                </div>
              </div>`;
          }
        },
        xAxis: {
          type: "category",
          data: info.y,
          show:false,
        },
        yAxis: {
          type: "value",
          data: info.x,
          axisLabel: {
            formatter: val => this.$retainWan(val,0,false),
            },
        },
        series: [
          {
            data: info.x,
            type: "line",
            showSymbol: false,
            lineStyle: {
            color: '#2877FF' // 设置线的颜色为红色
               },
          },
        ],
        grid: {
          left: this.FontChart(25),
          top: this.FontChart(9),
          bottom: this.FontChart(9),
          right: this.FontChart(5 ),
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.videoDay {
  margin-top: 0.24rem;
  width: 7rem;
  height: 3.5rem;
}
</style>